import { CheckinState } from '../reducers';

export const getIsServicesSaving = (state: CheckinState) => state.servicesLoading;
